/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Importing_Event_GroupsInputs */



/**
* | output |
* | --- |
* | "Importing Event Groups..." |
*
* @param {Automatic_Save_Importing_Event_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_importing_event_groups = /** @type {((inputs?: Automatic_Save_Importing_Event_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Importing_Event_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation des groupes d’événements...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisgruppen werden importiert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione di gruppi di eventi...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт групп событий...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importando grupos de eventos...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在导入事件组...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント グループをインポートしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट ग्रुप आयात किए जा रहे हैं...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importando grupos de eventos...")
	return /** @type {LocalizedString} */ ("Importing Event Groups...")
});